import React from 'react';
import { Chip } from '@mui/material';
import { SPICE_LEVELS, SpiceLevel } from '../types/menu';

interface SpiceLevelBadgeProps {
  spiceLevel: SpiceLevel;
  size?: 'small' | 'medium';
  showIcon?: boolean;
  className?: string;
}

const SpiceLevelBadge: React.FC<SpiceLevelBadgeProps> = ({
  spiceLevel,
  size = 'small',
  showIcon = true,
  className = ''
}) => {
  const config = SPICE_LEVELS[spiceLevel];

  if (!config) {
    return null;
  }

  // Don't show badge for NONE spice level
  if (spiceLevel === 'NONE') {
    return null;
  }

  return (
    <Chip
      label={
        <span className="flex items-center gap-1">
          {showIcon && config.icon && <span>{config.icon}</span>}
          <span>{config.displayName}</span>
        </span>
      }
      size={size}
      className={className}
      style={{
        backgroundColor: config.color + '20',
        color: config.color,
        fontWeight: 500,
        borderColor: config.color,
        borderWidth: '1px',
        borderStyle: 'solid'
      }}
    />
  );
};

export default SpiceLevelBadge;
